import React from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useLocation } from "react-router-dom";
import ProductReferenceResponse from "../../../../api/models/ProductReferenceResponse";
import CustomDialog from "../../../../components/Dialog/CustomDialog";
import { ProductSuggestionFormType } from "../models/ProductSuggestion.form-model";
import SuggestionFormEmployee from "../models/ProductSuggestionForm/SuggestionFormEmployee";
import SuggestionFormRequester from "../models/ProductSuggestionForm/SuggestionFormRequester";

const PRODUCT_TAB = "/2";

export interface ProductSuggestionDialogProps {
  preset?: ProductReferenceResponse | null;
  readOnly: boolean;
  open: boolean;
  onClose: () => void;
  onConfirm: (product: ProductSuggestionFormType) => void;
  resetSalesProductInitialData: () => void;
}

const ProductSuggestionsDialog: React.FC<ProductSuggestionDialogProps> = ({
  preset,
  open,
  onClose,
  onConfirm,
  resetSalesProductInitialData,
}) => {
  const { pathname } = useLocation();

  let tabId = "";
  const suggestionFormTemplate = (path: string) => {
    tabId = `${path.charAt(path.length - 2)}${path.charAt(path.length - 1)}`;
    return tabId === PRODUCT_TAB ? (
      <SuggestionFormEmployee preset={preset} handleSubmit={onConfirm} />
    ) : (
      <SuggestionFormRequester preset={preset} handleSubmit={onConfirm} />
    );
  };

  return (
    <CustomDialog fullWidth maxWidth="sm" open={open} onClose={onClose} onExited={resetSalesProductInitialData}>
      <Box style={{ marginBottom: "20px" }}>
        <h2>SUGGEST TESA PRODUCT</h2>
        <Typography>
          Please enter the tesa product to be tested. The NART is preferred. Alternatively, entries for Product Name or
          Base Product according to product hierarchy 3 (PH3) are possible.
        </Typography>
      </Box>
      {suggestionFormTemplate(pathname)}
    </CustomDialog>
  );
};

export default ProductSuggestionsDialog;
